import React from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import './i18n';
import { TailSpin } from 'react-loader-spinner';
import { styled } from 'styled-components';

import useCustomToken from './hooks/useCustomToken';
import { CollapseProvider } from './hooks/useCollapse';
import { ActiveRoutesProvider } from './hooks/useActiveRoutes';
import useAuth from './hooks/useAuth';

import routes from './routes/Routes';
import { withConfigProvider } from './static/withConfigProvider';
import { ThemeProvider } from './contexts/ThemeContext';
import { EmailStatusProvider } from './contexts/EmailStatusContext';

const Container = styled('div')`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const App = () => {
  const content = useRoutes(routes);
  const { isLoading } = useAuth();
  const token = useCustomToken();
  const location = useLocation();
  const helpdesk = document.getElementById('launcher-frame');

  if (isLoading) {
    return (
      <>
        <Container>
          <TailSpin
            color={token?.colorTextTertiary}
          />
        </Container>
      </>
    );
  }

  if (helpdesk) {
    helpdesk.style.display = (location.pathname === '/') ? 'none' : 'block';
  }

  return (
    <ThemeProvider>
      <CollapseProvider>
        <ActiveRoutesProvider>
          <EmailStatusProvider>
            {withConfigProvider(<>{content}</>)}
          </EmailStatusProvider>
        </ActiveRoutesProvider>
      </CollapseProvider>
    </ThemeProvider>
  );
};

export default App;
